module.exports = "https://static.wmbcdn.com/uniweb/images/86dc74636e4d1c1acf7e9dbabdf0cc2e.svg";